export default "__VITE_ASSET__ebf26464__"